import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button } from 'react-bootstrap';
import generic43 from 'assets/img/generic/43.webp';
import { faPen, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { SITE_ENDPOINT } from 'Constant';

const CoverImage = ({
  handleClose,
  id,
  imageUrl,
  canEditJob
}: {
  handleClose: () => void;
  id?: string;
  imageUrl?: string;
  canEditJob?: boolean;
}) => {
  return (
    <>
      {canEditJob && (
        <Link to={`${SITE_ENDPOINT.BASE}${SITE_ENDPOINT.JOB.EDIT}/${id}`}>
          <label
            className="position-absolute top-0 start-0"
            htmlFor="projectCoverInput"
          >
            <span className="project-modal-btn d-inline-block dark__text-white bg-primary rounded-2 py-2 px-3 fs-9 fw-bolder mt-3 ms-3 cursor-pointer">
              <FontAwesomeIcon icon={faPen} className="me-1" />
              Edit Job
            </span>
          </label>
        </Link>
      )}

      <Button
        variant="circle"
        className="project-modal-btn position-absolute end-0 top-0 mt-3 me-3 bg-white"
        onClick={handleClose}
      >
        <FontAwesomeIcon icon={faXmark} />
      </Button>
      <img
        src={imageUrl || generic43}
        alt="cover"
        className="cursor-pointer mx-auto d-block"
        style={{
          maxWidth: '100%',
          maxHeight: '150px',
          height: 'auto',
          width: 'auto'
        }}
      />
    </>
  );
};

export default CoverImage;
